var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "occupation-preview" }, [
    _c("div", { staticClass: "occupation-preview__label" }, [
      _vm._v("Pré-visualização"),
    ]),
    _c("div", { staticClass: "occupation-preview__bar" }, [
      _c(
        "div",
        {
          staticClass:
            "occupation-preview__segment occupation-preview__segment--green",
          style: { width: _vm.greenWidth + "%" },
        },
        [
          _vm.greenWidth > 8
            ? _c("span", { staticClass: "occupation-preview__text" }, [
                _vm._v(_vm._s(_vm.green) + "%"),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "occupation-preview__segment occupation-preview__segment--yellow",
          style: { width: _vm.yellowWidth + "%" },
        },
        [
          _vm.yellowWidth > 8
            ? _c("span", { staticClass: "occupation-preview__text" }, [
                _vm._v(_vm._s(_vm.yellow) + "%"),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "occupation-preview__segment occupation-preview__segment--orange",
          style: { width: _vm.orangeWidth + "%" },
        },
        [
          _vm.orangeWidth > 8
            ? _c("span", { staticClass: "occupation-preview__text" }, [
                _vm._v(_vm._s(_vm.red) + "%"),
              ])
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass:
            "occupation-preview__segment occupation-preview__segment--red",
          style: { width: _vm.redWidth + "%" },
        },
        [
          _vm.redWidth > 0
            ? _c("span", { staticClass: "occupation-preview__text" }, [
                _vm._v("100%"),
              ])
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }